import { CustomError } from "@baqhub/sdk";
export class InvalidActionError extends CustomError {
    constructor(state, action) {
        super("Invalid action: " + JSON.stringify({ state, action }));
    }
}
